import {createContext} from 'react'
import {CommissionContext} from './_context'

export const CommissionProvider = CommissionContext.Provider
